import { useQuery } from "@tanstack/react-query";
import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { AuthContext } from "../Context/ContextProvider";
import Loader from "../Loader/Loader";
import OrderCard from "./OrderCard/OrderCard";

const MyOrders = () => {
  const { user, loader } = useContext(AuthContext);
  const email = user?.email;
  const {
    data: bookingProduct = [],
    isLoading,
    refetch,
    error,
  } = useQuery({
    queryKey: ["order"],
    queryFn: () =>
      fetch(
        `https://used-phone-resale-server-side.vercel.app/bookingProduct?email=${email}`
      ).then((res) => res.json()),
  });

  if (isLoading || loader) {
    return <Loader />;
  }
  if (!bookingProduct?.length) {
    return (
      <div>
        <h1>Your booking product is 0</h1>
        <p>Please booking Your fav. product </p>
        <div className="divider font-extrabold"></div>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 gap-3">
      {bookingProduct.map((product) => (
        <OrderCard key={product._id} product={product} isLoading={isLoading} />
      ))}
    </div>
  );
};

export default MyOrders;
